module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.welcome_accept) ? _c('mu-dialog', {
    attrs: {
      "width": "760",
      "open": _vm.dialog,
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "id": "hcpGettingStartedModal"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/hcp/hcp_showcase.png"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Welcome to the Healthcare Professional Platform")]), _vm._v(" "), _c('p', [_vm._v("Created for clinicians by clinicians to assist you in achieving safe, effective and efficient care for your patients.")]), _vm._v(" "), _c('p', [_vm._v("The Low Carb Program provides education and support for people with conditions that can benefit from lifestyle interventions. Condition specific programs are currently available for people with type 2 diabetes, prediabetes or obesity. (Further evidence-based programs are in development)")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btn",
    attrs: {
      "primary": "",
      "label": "Get Started",
      "fullWidth": ""
    },
    on: {
      "click": function($event) {
        return _vm.acceptWelcome()
      }
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62c45a64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP/GettingStartedModal.vue
// module id = 3200
// module chunks = 1